var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 274.828,
    viewBox: "0 0 300 274.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#1976d2}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(-.001 -21.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    fill: "#64b5f6",
    d: "M304.168 316.713l-37.5-37.561a6.25 6.25 0 0 0-10.675 4.413v87.559a6.249 6.249 0 0 0 4.275 5.925 6.168 6.168 0 0 0 1.975.325 6.249 6.249 0 0 0 5-2.5l37.5-50a6.249 6.249 0 0 0-.575-8.161z",
    "data-name": "Path 7329",
    transform: "translate(-106.004 -105.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7330",
    d: "M259.047 311.578l-37.5-12.5a6.25 6.25 0 0 0-7.912 7.9l25 75a6.249 6.249 0 0 0 5.937 4.275h.387a6.249 6.249 0 0 0 5.737-5l12.5-62.5a6.25 6.25 0 0 0-4.149-7.175z",
    className: "cls-2",
    "data-name": "Path 7330",
    transform: "translate(-88.331 -114.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    fill: "#2196f3",
    d: "M332.642 22.649a6.25 6.25 0 0 0-6.712-.288L88.439 159.856a6.25 6.25 0 0 0 1.161 11.337l112.245 37.424 87.247 37.4a6.249 6.249 0 0 0 8.612-4.662L335.2 28.861a6.25 6.25 0 0 0-2.558-6.212z",
    "data-name": "Path 7331",
    transform: "translate(-35.331 -.016)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9684",
    "data-name": "Group 9684",
    transform: "translate(0 21.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7332",
    d: "M388.1 31.383a6.25 6.25 0 0 0-9.512-8.05L215.611 195.226l47.035 16.249z",
    className: "cls-2",
    "data-name": "Path 7332",
    transform: "translate(-89.282 -21.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    d: "M15.272 405.288a6.25 6.25 0 0 1-4.237-1.65q-4.675-4.3-9.2-8.837a6.253 6.253 0 1 1 8.837-8.85q4.35 4.35 8.837 8.487a6.25 6.25 0 0 1-4.237 10.85z",
    className: "cls-2",
    "data-name": "Path 7333",
    transform: "translate(0 -171.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7334",
    d: "M123.369 466.006a89.949 89.949 0 0 1-17.924-1.863 6.25 6.25 0 1 1 2.017-12.336c.162.026.324.06.483.1a77.54 77.54 0 0 0 15.462 1.6h2.85a5.925 5.925 0 0 1 6.487 6.012 6.25 6.25 0 0 1-6.012 6.475h-3.262zm-44.785-11.962a6.248 6.248 0 0 1-2.875-.7 163.22 163.22 0 0 1-17.762-10.787 6.25 6.25 0 0 1 7.125-10.262 148.27 148.27 0 0 0 16.375 10 6.25 6.25 0 0 1-2.875 11.8z",
    className: "cls-2",
    "data-name": "Path 7334",
    transform: "translate(-22.951 -191.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7335",
    d: "M221.782 466.32a6.25 6.25 0 0 1-2.5-12 90.749 90.749 0 0 0 10.462-5.3 6.25 6.25 0 0 1 6.35 10.762 103.715 103.715 0 0 1-11.9 6.037 6.257 6.257 0 0 1-2.412.501z",
    className: "cls-2",
    "data-name": "Path 7335",
    transform: "translate(-89.228 -198.192)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.6e728eab5b96258b27bcb12315b39ca6.svg";
export { ForwardRef as ReactComponent };